package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_12_07_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who are traveling towards the Brij bridge and have recently engaged giant scorpions and ankhegs. The heroes swiftly destroy their enemies. Bigglesworth and Annette harvest meat — “they” say that Ankheg are the “Lobster of the Land.” Tuesday briefly complains about eating meat when vegetables are plentiful. Annette purifies both of their scavenged meats.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes continue on and later setup camp for the night. During his watch, Dirk spots a shrine to Toramokan, neutral god of weather, through the darkness.")
    }
}
